import HBIcon from "@/components/HBIcon";
import useAppStore from "@/context/store";
import { useListenScrollDirection } from "@/utils/hooks/useListenScrollDirection";
import classNames from "classnames";
import { useState } from "react";
import { When } from "react-if";
import FromDialog from "../FormModal";
import styles from "./index.module.less";

const icon =
  "https://grocery-cdn.huaban.com/file/a0436e60-efef-11ee-9c0b-c38e922e51f3.png";

export default function Header(props) {
  const advantage = [
    <>
      <span className={classNames([styles.color, styles.fontsize18])}>1.3</span>
      <span className={styles.color}>亿</span>高清图片供给
    </>,
    <>
      <span className={classNames([styles.color, styles.fontsize18])}>
        100%
      </span>
      全球正版商业授权
    </>,
    <>
      <span className={styles.color}>多主体/多行业/多场景 </span>覆盖
    </>,
  ];
  const { isMobile, config } = props;
  const { headerHeight: height, user } = useAppStore(
    ({ headerHeight, user }) => ({
      headerHeight,
      user,
    })
  );
  const [showHeader, setShowHeader] = useState(false);
  const [disable, setDisable] = useState(isMobile);
  useListenScrollDirection(
    () => {
      setShowHeader(false);
    },
    () => {
      setShowHeader(true);
    }
  );
  const openModal = () => {
    FromDialog.open({
      config,
      isMobile,
    });
  };
  const closeFiexdHeader = () => {
    setDisable(true);
  };
  return (
    <>
      <When condition={!disable && !!user}>
        <div
          className={classNames([
            styles.fixed,
            showHeader ? styles.show : null,
          ])}
        >
          <div className={styles.fixedContent}>
            <div className={styles.fixedDesc}>
              欢迎联系专属顾问，为您按需定制授权方案
            </div>
            <div className={styles.btn}>
              <span onClick={openModal}>立即咨询</span>
            </div>
            <HBIcon
              type="ic_close"
              className={styles.close}
              onClick={closeFiexdHeader}
            />
          </div>
        </div>
      </When>

      <div
        className={classNames(styles.content, {
          [styles.mobile]: isMobile,
        })}
      >
        <div className={styles.left}>
          <div className={styles.headerContent}>
            <div className={styles.header}>花瓣素材</div>
            <div className={classNames([styles.headerDesc, styles.header])}>
              大企业授权定制
            </div>
          </div>

          <div className={styles.advantage}>
            {isMobile ? (
              <div>
                <span className={styles.color}>1.3亿</span>
                高清图片供给, <span className={styles.color}>100%</span>
                全球正版商用授权,
                <span className={styles.color}>多主体/多行业/多场景</span>覆盖
              </div>
            ) : (
              advantage.map((item, index) => (
                <div key={index} className={styles.item}>
                  <img src={icon} alt="" />
                  <div className={styles.itemDesc}>{item}</div>
                </div>
              ))
            )}
          </div>
          <When condition={isMobile}>
            <div className={styles.btn} onClick={openModal}>
              立即咨询
            </div>
          </When>
        </div>
      </div>
    </>
  );
}
